module.exports = __webpack_public_path__ + "images/emoji/crossed_flags.cca96eadba8cc30d4691.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/crossed_flags.png
// module id = lgSb
// module chunks = 24